import React from 'react';

type Props = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

function CustomTabPanel({children, value, index, ...other}: Props) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

export default CustomTabPanel;
